import {
  DateField,
  Datagrid,
  Edit,
  EditButton,
  Filter,
  List,
  Resource,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from "react-admin";

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Material Name" source="name" alwaysOn />
  </Filter>
);

const MaterialList = (props) => (
  <List {...props} filters={<Filters />} bulkActionButtons={false}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Material Name" />
      <DateField source="createdAt" label="Created at" />
      <DateField source="updatedAt" label="Updated at" />
      <EditButton />
    </Datagrid>
  </List>
);

const ShowMaterial = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Material Name" />
      <DateField source="createdAt" label="Created at" />
      <DateField source="updatedAt" label="Updated at" />
    </SimpleShowLayout>
  </Show>
);

const EditMaterial = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id" label="ID" disabled />
      <TextInput source="name" label="Material Name" />
      <TextInput source="createdAt" label="Created at" disabled />
      <TextInput source="updatedAt" label="Updated at" disabled />
    </SimpleForm>
  </Edit>
);

const materialResource = () => (
  <Resource
    name="material"
    options={{ label: "Historical Materials", menuGroup: "Materials" }}
    list={MaterialList}
    edit={EditMaterial}
    show={ShowMaterial}
  />
);

export default materialResource;
